import React, { useState } from "react"
import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from 'react-helmet'
import { GlobalWrapper, LayoutWrapper, MainDiv } from './style'
import useEventListener from '@use-it/event-listener'
import favicon from '../../images/favicon32.png'
import Header from "../header/index"
// import PopUpBlackFriday from '../popup/blackfriday'
import Footer from '../footer/index'
import "./layout.css"

const Layout = ({ children, paintHeader }) => {
  const [ withBackground, setWithBackground] = useState(false)
  // const data = useStaticQuery(graphql`
  //   query SiteTitleQuery {
  //     site {
  //       siteMetadata {
  //         title
  //       }
  //     }
  //   }
  // `)

  const onScroll = event => {
    let currentPosition = window.pageYOffset;
    setWithBackground( currentPosition > 200 )
  }

  useEventListener('scroll', onScroll)

  return (
    <LayoutWrapper paddingTop={paintHeader}>
      <GlobalWrapper />
      <Helmet
        htmlAttributes={{
          lang: 'pt-br',
        }}
        >
        <link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;1,300;1,400&display=swap" rel="stylesheet" />
        <link rel="icon" href={favicon} />
        <meta name="adopt-website-id" content="78ef1068-840c-4ada-af0d-2d7f81f20890" />
        <script src="//tag.goadopt.io/injector.js?website_code=78ef1068-840c-4ada-af0d-2d7f81f20890" class="adopt-injector"></script>
      </Helmet>      
      <Header withBackground={withBackground} paintHeader={paintHeader} />
      <MainDiv>{children}</MainDiv>
      <Footer />
      {/* <PopUpBlackFriday /> */}
    </LayoutWrapper>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
